import { css } from '@rxdi/lit-html';

export const globalStyles = css`
  html,
  body {
    padding: 0;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans,
      Helvetica Neue, sans-serif;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
    --secondary-color: rgb(214, 214, 214);
    --secondary-color-hover: rgb(224, 224, 224);
    --radius: 4px;
  }
`;
